// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.coming-soon__wrapper {
	min-height: calc(100vh - 80px);
	display: flex;
	align-items: center;
	padding: 80px 0;
	position: relative;
	overflow: hidden;
	justify-content: center;
}

.coming-soon__content {
	display: flex;
	flex-direction: column;
	gap: 24px;
	max-width: 1340px;
	width: 100%;
	padding: 0 24px;
}

.coming-soon__title {
	text-transform: uppercase;
	font-size: 96px;
	color: #000000;
	font-weight: 500;
	font-family: "Pridi", serif !important;
	max-width: 800px;
	line-height: 100%;
}

.coming-soon__description {
	font-size: 20px;
	color: #333333;
	font-weight: 400;
	max-width: 700px;
}

.coming-soon__form {
	max-width: 680px;
	display: flex;
	flex-direction: column;
	gap: 30px;
}

.coming-soon__form-group {
	display: flex;
	flex-direction: column;
	gap: 6px;
}

.coming-soon__default-sliding-text-block {
	position: absolute;
	height: 68px;
	width: 100%;
	bottom: -80px;
	left: 50%;
	transform: rotate(-45deg);
	transform-origin: 0 0;
	display: flex;
	align-items: center;
	background-color: white;
	z-index: 2;
}

.coming-soon__features-sliding-text-block {
	position: absolute;
	height: 68px;
	width: 100%;
	top: -80px;
	left: 60%;
	transform: rotate(45deg);
	transform-origin: 0 0;
	display: flex;
	align-items: center;
	background-color: #4db8ff;
	z-index: 1;
}

.coming-soon__default-sliding-text-marquee {
	overflow: hidden;
	white-space: nowrap;
	width: 100%;
}

.marquee__inner {
	display: inline-block;
	white-space: nowrap;
	will-change: transform;
	animation: marquee 10s linear infinite;
}

.marquee__inner span {
	display: inline-block;
	color: #4db8ff;
	font-size: 32px;
	font-weight: 500;
	line-height: 100%;
	padding-right: 64px;
}

.marquee__inner.white span {
	color: white;
	text-transform: uppercase;
}

.marquee__inner.white {
	animation: marquee 15s linear infinite;
}

@keyframes marquee {
	0% {
		transform: translateX(0%);
	}

	100% {
		transform: translateX(-50%);
	}
}

@media (max-width: 1150px) {
	.coming-soon__title {
		text-transform: uppercase;
		font-size: 80px;
		color: #000000;
		font-weight: 500;
		font-family: "Pridi", serif !important;
		max-width: 800px;
		line-height: 100%;
	}
}

@media (max-width: 950px) {
	.coming-soon__wrapper {
		min-height: calc(100vh - 80px);
		display: flex;
		align-items: center;
		padding: 40px 0;
		position: relative;
		overflow: hidden;
		justify-content: center;
	}

	.coming-soon__default-sliding-text-block {
		display: none;
	}

	.coming-soon__features-sliding-text-block {
		display: none;
	}

	.coming-soon__title {
		text-transform: uppercase;
		font-size: 52px;
		color: #000000;
		font-weight: 500;
		font-family: "Pridi", serif !important;
		max-width: 800px;
		line-height: 100%;
	}

	.coming-soon__description {
		font-size: 16px;
		color: #333333;
		font-weight: 400;
		max-width: 700px;
	}
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/LendingPage/ComingSoon/ComingSoon.css"],"names":[],"mappings":"AAAA;CACC,8BAA8B;CAC9B,aAAa;CACb,mBAAmB;CACnB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,uBAAuB;AACxB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;CACT,iBAAiB;CACjB,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,sCAAsC;CACtC,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,aAAa;CACb,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,QAAQ;AACT;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,WAAW;CACX,aAAa;CACb,SAAS;CACT,yBAAyB;CACzB,qBAAqB;CACrB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,WAAW;CACX,UAAU;CACV,SAAS;CACT,wBAAwB;CACxB,qBAAqB;CACrB,aAAa;CACb,mBAAmB;CACnB,yBAAyB;CACzB,UAAU;AACX;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,qBAAqB;CACrB,mBAAmB;CACnB,sBAAsB;CACtB,sCAAsC;AACvC;;AAEA;CACC,qBAAqB;CACrB,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,yBAAyB;AAC1B;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC;EACC,yBAAyB;CAC1B;;CAEA;EACC,2BAA2B;CAC5B;AACD;;AAEA;CACC;EACC,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,sCAAsC;EACtC,gBAAgB;EAChB,iBAAiB;CAClB;AACD;;AAEA;CACC;EACC,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;CACxB;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,sCAAsC;EACtC,gBAAgB;EAChB,iBAAiB;CAClB;;CAEA;EACC,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;CACjB;AACD","sourcesContent":[".coming-soon__wrapper {\n\tmin-height: calc(100vh - 80px);\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 80px 0;\n\tposition: relative;\n\toverflow: hidden;\n\tjustify-content: center;\n}\n\n.coming-soon__content {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 24px;\n\tmax-width: 1340px;\n\twidth: 100%;\n\tpadding: 0 24px;\n}\n\n.coming-soon__title {\n\ttext-transform: uppercase;\n\tfont-size: 96px;\n\tcolor: #000000;\n\tfont-weight: 500;\n\tfont-family: \"Pridi\", serif !important;\n\tmax-width: 800px;\n\tline-height: 100%;\n}\n\n.coming-soon__description {\n\tfont-size: 20px;\n\tcolor: #333333;\n\tfont-weight: 400;\n\tmax-width: 700px;\n}\n\n.coming-soon__form {\n\tmax-width: 680px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 30px;\n}\n\n.coming-soon__form-group {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 6px;\n}\n\n.coming-soon__default-sliding-text-block {\n\tposition: absolute;\n\theight: 68px;\n\twidth: 100%;\n\tbottom: -80px;\n\tleft: 50%;\n\ttransform: rotate(-45deg);\n\ttransform-origin: 0 0;\n\tdisplay: flex;\n\talign-items: center;\n\tbackground-color: white;\n\tz-index: 2;\n}\n\n.coming-soon__features-sliding-text-block {\n\tposition: absolute;\n\theight: 68px;\n\twidth: 100%;\n\ttop: -80px;\n\tleft: 60%;\n\ttransform: rotate(45deg);\n\ttransform-origin: 0 0;\n\tdisplay: flex;\n\talign-items: center;\n\tbackground-color: #4db8ff;\n\tz-index: 1;\n}\n\n.coming-soon__default-sliding-text-marquee {\n\toverflow: hidden;\n\twhite-space: nowrap;\n\twidth: 100%;\n}\n\n.marquee__inner {\n\tdisplay: inline-block;\n\twhite-space: nowrap;\n\twill-change: transform;\n\tanimation: marquee 10s linear infinite;\n}\n\n.marquee__inner span {\n\tdisplay: inline-block;\n\tcolor: #4db8ff;\n\tfont-size: 32px;\n\tfont-weight: 500;\n\tline-height: 100%;\n\tpadding-right: 64px;\n}\n\n.marquee__inner.white span {\n\tcolor: white;\n\ttext-transform: uppercase;\n}\n\n.marquee__inner.white {\n\tanimation: marquee 15s linear infinite;\n}\n\n@keyframes marquee {\n\t0% {\n\t\ttransform: translateX(0%);\n\t}\n\n\t100% {\n\t\ttransform: translateX(-50%);\n\t}\n}\n\n@media (max-width: 1150px) {\n\t.coming-soon__title {\n\t\ttext-transform: uppercase;\n\t\tfont-size: 80px;\n\t\tcolor: #000000;\n\t\tfont-weight: 500;\n\t\tfont-family: \"Pridi\", serif !important;\n\t\tmax-width: 800px;\n\t\tline-height: 100%;\n\t}\n}\n\n@media (max-width: 950px) {\n\t.coming-soon__wrapper {\n\t\tmin-height: calc(100vh - 80px);\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tpadding: 40px 0;\n\t\tposition: relative;\n\t\toverflow: hidden;\n\t\tjustify-content: center;\n\t}\n\n\t.coming-soon__default-sliding-text-block {\n\t\tdisplay: none;\n\t}\n\n\t.coming-soon__features-sliding-text-block {\n\t\tdisplay: none;\n\t}\n\n\t.coming-soon__title {\n\t\ttext-transform: uppercase;\n\t\tfont-size: 52px;\n\t\tcolor: #000000;\n\t\tfont-weight: 500;\n\t\tfont-family: \"Pridi\", serif !important;\n\t\tmax-width: 800px;\n\t\tline-height: 100%;\n\t}\n\n\t.coming-soon__description {\n\t\tfont-size: 16px;\n\t\tcolor: #333333;\n\t\tfont-weight: 400;\n\t\tmax-width: 700px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
